const JSONparse = (value, defaultValue) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return defaultValue;
  }
};

export const ReadProductCardAttributes = (productCard) => {
  const images = JSONparse(productCard.dataset['images']);
  const price = JSONparse(productCard.dataset['price']);
  const packSize = parseInt(productCard.dataset['packsize']);
  const isInStock = productCard.dataset['isinstock'] === 'True';
  const showBuyButton = productCard.dataset['showbuybutton'] === 'True';
  const showPackButton = productCard.dataset['showpackbutton'] === 'True';
  const stockStatusDescription = productCard.dataset['stockdescription'];
  const unitOfMeasurementTitle = productCard.dataset['unitofmeasurementtitle'];
  const currentPriceFormatted = productCard.dataset['currentpriceformatted'];
  const showBuyButtonAsIcon = productCard.dataset['showbuybuttonasicon'] === 'True';
  const fieldId = productCard.dataset['fieldid'];
  const showQuantityField = productCard.dataset['showquantityfield'] === 'True';
  const useVariantUrl = productCard.dataset['usevarianturl'] === 'True';
  const tags = JSONparse(productCard.dataset['tags'], []);
  const { name, url, id, type } = productCard.dataset;
  return {
    name,
    url,
    unitOfMeasurementTitle,
    id,
    packSize,
    tags,
    isInStock,
    stockStatusDescription,
    showBuyButton,
    showBuyButtonAsIcon,
    showQuantityField,
    useVariantUrl,
    fieldId,
    showPackButton,
    images,
    price,
    currentPriceFormatted,
    type,
  };
};
